import type { Envelope } from './types'

export async function collectPages<T>(load: (cursor?: string) => Promise<Envelope<T[]>>): Promise<Envelope<T[]>> {
  const data: T[] = [], seen = new Set<string>()
  let cursor: string | undefined
  do {
    const page = await load(cursor)
    data.push(...page.data)
    cursor = page.next_cursor || undefined
    if (cursor && seen.has(cursor)) throw new Error('列表分页异常，请刷新后重试')
    if (cursor) seen.add(cursor)
  } while (cursor)
  return { trace_id: '-', data }
}
